import React, { useState } from 'react';
import PropTypes from 'prop-types';
import MuiRating from '@material-ui/lab/Rating';
import { Box, useTheme } from '@material-ui/core'; //TODO: replace with our Box
import Typography from 'components/atoms/Typography/Typography';

/**
 * Default Rating component based on https://material-ui.com/components/rating/
 * @param {*} props All possible props can be found in docs https://material-ui.com/components/rating/#api
 */
export default function Rating(props) {
  const { value, nullPlaceholder, ...rest } = props;
  const [hover, setHover] = useState(-1);
  const theme = useTheme();
  const themeColor = theme && theme.palette.primary.main;

  return (
    <Box display="flex">
      <MuiRating
        name="rating"
        onChangeActive={(event, newHover) => {
          setHover(newHover);
        }}
        {...rest}
      />

      <Box ml={1} width="40px">
        {value !== null ? (
          <Typography variant="body1" textColor={themeColor}>
            {hover !== -1 ? hover : value}
          </Typography>
        ) : (
          <Typography>{nullPlaceholder}</Typography>
        )}
      </Box>
    </Box>
  );
}

Rating.propTypes = {
  /**
   * Placeholder text when no value is selected
   */
  nullPlaceholder: PropTypes.string,
};
